(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["starry-buying-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('starry-buying-help')) {
    customElements.define('starry-buying-help', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('product-form');
        this.status = this.querySelector('[data-starry-stock]');
        this.dispatch = this.querySelector('[data-starry-dispatch]');
        this.variants = JSON.parse(this.querySelector('[data-starry-stock-json]').textContent);
        this.onVariantChange = (event) => {
          const state = event.detail.variant && this.variants[event.detail.variant.id];
          this.status.textContent = state ? (this.dataset.defaultVariant === 'true' ? '' : state.title + ': ') + state.text : this.dataset.unavailable;
          if (this.dispatch) this.dispatch.hidden = !state || !state.inStock;
        };
        this.form?.addEventListener('theme:variant:change', this.onVariantChange);
      }
      disconnectedCallback() {
        this.form?.removeEventListener('theme:variant:change', this.onVariantChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
